// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1___df5249ff9dffcf81fe9","cls2":"MultiPaperNewsStory-cls2__d2e2e4b9d6b436c2a4e2 MultiPaperNewsStory-cls1___df5249ff9dffcf81fe9"};